import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";

export const CheckinDialog = ({ open, onOpenChange, plan }) => {
  const [rating, setRating] = useState(0);
  const [note, setNote] = useState("");
  const [visited, setVisited] = useState(plan.stops.map((s) => s.sid));
  const nav = useNavigate();

  const submit = async () => {
    if (!rating) return toast.error("Tap a rating first.");
    try {
      const { data } = await api.post(`/plans/${plan.id}/checkin`, { rating, note, visited_sids: visited });
      toast.success(data.new_places ? `Added to your journal: ${data.new_places} new place${data.new_places > 1 ? "s" : ""} discovered!` : "Added to your journal");
      onOpenChange(false);
      nav("/outings");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="z-[1250] sm:max-w-md" data-testid="checkin-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl">How was it?</DialogTitle>
          <DialogDescription>Your answer shapes future plans and adds this outing to your private journal.</DialogDescription>
        </DialogHeader>
        <div className="flex gap-1.5" data-testid="checkin-modal-rating">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} data-testid={`checkin-rating-${n}`} onClick={() => setRating(n)} className="p-1 transition-transform active:scale-90">
              <Star className={`w-8 h-8 ${n <= rating ? "fill-amber-400 text-amber-400" : "text-stone-300"}`} />
            </button>
          ))}
        </div>
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-wider font-semibold text-stone-500">Where did you actually go?</p>
          {plan.stops.map((s, i) => (
            <label key={s.sid} className="flex items-center gap-2 text-sm">
              <Checkbox data-testid={`checkin-visited-${i + 1}`} checked={visited.includes(s.sid)}
                onCheckedChange={(v) => setVisited(v ? [...visited, s.sid] : visited.filter((x) => x !== s.sid))} /> {s.name}
            </label>
          ))}
        </div>
        <textarea data-testid="checkin-note" value={note} onChange={(e) => setNote(e.target.value)} rows={2} placeholder="A moment worth remembering? (optional)"
          className="w-full rounded-lg border border-stone-300 p-3 text-sm" />
        <button data-testid="checkin-modal-submit" onClick={submit} className="w-full bg-[#2F7D55] hover:bg-[#23603F] text-white font-semibold py-2.5 rounded-xl transition-colors">Save to my outings</button>
      </DialogContent>
    </Dialog>
  );
};
